const Error403 = () => {
    return <h3>You can't access this page.</h3>
}

export default Error403;